module.exports = __webpack_public_path__ + "img/stock4.b69b5216.png";